import React from 'react'
import '../styles/HeaderStyle.css'
import LoginLogout from '../login/LoginLogout';

function ArtworkHeader() {

  return (
    <div id='headerDiv'>

        <a href='/' id='backButton'>Go Back</a>
        <h1 id='title'>Artwork</h1>
        <LoginLogout id="logoutButton"/>
    </div>
  )
}

export default ArtworkHeader
